<template>
  <svg
    width="46"
    height="43"
    viewBox="0 0 46 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2353 1.71406L30.2624 11.512C30.5416 12.3057 31.3812 12.8349 32.2207 12.8349L43.1145 14.4245C45.3478 14.6891 46.1874 17.337 44.5103 18.9266L36.6895 26.6057C36.1291 27.137 35.8499 27.9307 35.8499 28.9891L37.8062 39.8474C38.0853 41.9661 35.8499 43.5557 34.1749 42.4953L24.3957 37.4641C23.5791 37.1997 22.6999 37.1997 21.8832 37.4641L12.1041 42.4953C10.1499 43.5557 7.91448 41.9661 8.47282 39.8474L10.4291 28.9891C10.7082 28.1953 10.4291 27.4016 9.58948 26.6057L1.48948 18.662C-0.187599 17.337 0.649901 14.6891 2.88532 14.4245L13.7812 12.8349C14.6187 12.8349 15.4562 12.3057 15.7374 11.512L20.7645 1.71406C21.602 -0.404687 24.3978 -0.404687 25.2353 1.71406Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ProductMenuIcon4',
} as DefineComponent
</script>
